import { setHeaders, getQueryString } from "../../utils/fetch";

const getters = {
  pinwalls: state => state.pinwalls
};

const actions = {
  createPinwall(context, data) {
    return new Promise((resolve, reject) => {
      fetch(`${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/api/pinwall`, {
        method: "post",
        headers: setHeaders(
          {
            "Content-Type": "application/json"
          },
          context.getters.user
        ),
        body: JSON.stringify(data)
      })
        .then(res => {
          return res.json();
        })
        .then(function(data) {
          context.commit("addPinwall", data);
          resolve(data);
        })
        .catch(e => {
          window.console.error(e);
          reject();
        });
    });
  },
  likePinwall(context, data) {
    return new Promise((resolve, reject) => {
      const foundLike = context.getters.storedLikes.find(like => {
        return like === data.id;
      });

      if (foundLike) {
        return reject();
      }
      fetch(
        `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/api/pinwall/like/${
          data.id
        }`,
        {
          method: "put",
          headers: {
            "Content-type": "application/json"
          }
        }
      )
        .then(res => {
          if (!res.ok) {
            return reject();
          }
          context.commit("likePinwall", data);
          resolve();
        })
        .catch(e => {
          window.console.error(e);
          reject();
        });
    });
  },
  loadPinwalls(context, data) {
    return new Promise((resolve, reject) => {
      const scrollPosition = window.scrollY + window.innerHeight;
      const queryString = getQueryString(
        data.password,
        data.sort,
        window.innerWidth,
        null,
        context.getters.viewHeight > scrollPosition
          ? context.getters.viewHeight
          : scrollPosition
      );

      fetch(
        `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/api/pinwall/${
          data.tenant
        }/${data.space}?${queryString}`,
        {
          method: "get",
          headers: setHeaders(
            {
              "Content-Type": "application/json"
            },
            context.getters.user
          )
        }
      )
        .then(res => {
          return res.json();
        })
        .then(function(data) {
          context.commit("setPinwalls", data.pinwalls);
          resolve(data.space);
        })
        .catch(e => {
          context.commit("setPinwalls", []);
          window.console.error(e);
          reject();
        });
    });
  }
};

const mutations = {
  likePinwall(state, data) {
    state.pinwalls.map(pinwall => {
      if (pinwall.id === data.id) {
        pinwall.likes += 1;
      }
    });
  },
  setPinwalls(state, pinwalls) {
    state.pinwalls = pinwalls;
  },
  removePinwall(state, pinwall) {
    state.pinwalls = state.pinwalls.filter(p => {
      return p.id !== pinwall.id;
    });
  },
  addPinwall(state, pinwall) {
    state.pinwalls.unshift(pinwall);
  }
};

export default {
  state: initializeState(),
  mutations,
  actions,
  getters
};

function initializeState() {
  return {
    pinwalls: []
  };
}
